import { Link, useLocation } from "react-router-dom";
import { t as getFixedT } from "@/i18n";
import { BRAND } from "@/lib/brand";
import type { SupportedLanguage } from "@/lib/site";
import "./Footer.css";

interface FooterProps {
  lang: SupportedLanguage;
  otherLang: SupportedLanguage;
}

/** Footer — 09-landing-page.md §2.2 "4-column: عن الأكاديمية | روابط سريعة | تواصل | تابعنا". */
export function Footer({ lang, otherLang }: FooterProps) {
  const t = getFixedT(lang);
  const location = useLocation();
  const otherLangHref = `/${otherLang}${location.hash || ""}`;

  return (
    <footer className="fa-footer">
      <div className="fa-section-inner fa-footer__grid">
        <div>
          <div className="fa-footer__brand">
            <img
              src="/academy-logo.jpeg"
              alt={lang === "ar" ? BRAND.nameAr : BRAND.nameEn}
              className="fa-footer__logo"
              width="40"
              height="40"
            />
            <span>{lang === "ar" ? BRAND.nameAr : BRAND.nameEn}</span>
          </div>
          <p className="fa-footer__about">{t("footer.about")}</p>
        </div>
        <div>
          <p className="fa-footer__heading">{t("footer.quickLinksHeading")}</p>
          <ul className="fa-footer__list">
            <li>
              <a href="#why-us">{t("nav.whyUs")}</a>
            </li>
            <li>
              <a href="#programs">{t("nav.programs")}</a>
            </li>
            <li>
              <a href="#faq">{t("nav.faq")}</a>
            </li>
            <li>
              <a href="#lead-form">{t("hero.cta")}</a>
            </li>
          </ul>
        </div>
        <div>
          <p className="fa-footer__heading">{t("footer.contactHeading")}</p>
          <ul className="fa-footer__list">
            <li>
              <a href={`tel:${BRAND.phoneE164}`}>
                <bdi>{BRAND.phoneDisplay}</bdi>
              </a>
            </li>
            <li>
              <a href={`mailto:${BRAND.email}`}>{BRAND.email}</a>
            </li>
            <li>{lang === "ar" ? BRAND.addressAr : BRAND.addressEn}</li>
          </ul>
        </div>
        <div>
          <p className="fa-footer__heading">{t("footer.followHeading")}</p>
          <ul className="fa-footer__list fa-footer__social">
            <li>
              <a
                href={BRAND.facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
            </li>
            <li>
              <a
                href={BRAND.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>
            </li>
          </ul>
          <Link
            to={otherLangHref}
            hrefLang={otherLang}
            lang={otherLang}
            className="fa-footer__lang-switch"
          >
            {t("nav.languageSwitchShort")}
          </Link>
        </div>
      </div>
      <div className="fa-footer__legal">
        <p>{t("footer.copyright", { year: new Date().getFullYear() })}</p>
        <Link to={`/${lang}/privacy`}>{t("footer.privacyLink")}</Link>
      </div>
    </footer>
  );
}
